import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import actionMappings from '../action-factory/ProjectActions';

export const useProjectActions = (projectVariant, projectType) => {
  const dispatch = useDispatch();

  return useCallback(
    (actionName, args) => {
      const actionConfig = actionMappings[projectType]?.[actionName];

      if (!actionConfig) {
        throw new Error(`Action ${actionName} not found for module ${projectType}`);
      }

      const action = actionConfig[projectVariant];
      const transformedArgs = actionConfig.argsTransformer ? actionConfig.argsTransformer(args, projectVariant) : args;

      return dispatch(action(transformedArgs));
    },
    [dispatch, projectVariant, projectType],
  );
};
